import React, { useState, useRef,useEffect} from 'react';
import SeveritySelector from './SeveritySelector';
import MultiSelectFilter from './MultiSelectFilter';
import './styles/panelFiltros.css';
import { lang } from '../../generales/traduction';
import { useFetch } from '../../../hooks/useFetch';
import { capitalizeFirstLetter } from '../../../utils/utils';
import Action from '../../Action';
import SelectorAdmin from '../../SelectorAdmin';
import MultiSelector from '../../MultiSelector';
import { ta } from 'date-fns/locale';
// import { lang } from '../../generales/traduction';
const ActionsPanel = ({ isOpen,severityFilter, setSeverityFilter,import_info,update_info,crear,
  statusFilter,
    techFilter,
    groupFilter,
    zoneFilter,
    ackFilter,
    ticketFilter,tipoFilter,
    setStatusFilter,
    setTechFilter,
    setGroupFilter,
    setZoneFilter,
    setAckFilter,setTipoFilter,
    setTicketFilter
    ,filters, onFilterChange,yourData,buscar_cis,setManttoData,ManttoData,handleShowPopup,setSearchTerm,languaje,mode,user,dataUsers,devices,server,setRegisterIsValid,groupSelected,setData,loading,setLoading,setError,setEditActive,editActive,closCreateCisModal}) => {
  
  const [isDragging, setIsDragging] = useState(false);
  // // console.log(window)
  const [position, setPosition] = useState({ x: -300, y: 50 }); // Posición inicial en la esquina superior derecha
  const offset = useRef({ x: 0, y: 0 });
// console.log(position)
//   const togglePanel = () => {
//     setIsOpen(!isOpen);
//   };

  const handleClearFilters = () => {
    // Reset all filters to their initial state
    const defaultFilters = {
      searchTerm: '',
      severities: [],
      statuses: ['PROBLEMA'], // Default value from your HTML
      techs: [],
      groups: [],
      zones: [],
      ack: null,
      ticket: null,
    };
    onFilterChange(defaultFilters);
  };
// Función para iniciar el arrastre
const handleMouseDown = (e) => {
  // Evita arrastrar si se hace clic en un elemento interactivo
  if (e.target.closest('button, input, .tag, .options-dropdown div')) {
    return;
  }
  
  setIsDragging(true);
  const panel = e.currentTarget;
  offset.current.x = e.clientX - panel.offsetLeft;
  offset.current.y = e.clientY - panel.offsetTop;
};

// Función para mover el panel
const handleMouseMove = (e) => {
  if (!isDragging) return;
  
  var newX = e.clientX - offset.current.x;
  var newY = e.clientY - offset.current.y;
if(newX>-250){
 newX=-250
};
if((newY+500)>window.innerHeight){
 newY=window.innerHeight-500
}


 setPosition({ x: newX, y: newY });
}
// Función para detener el arrastre
const handleMouseUp = () => {
  setIsDragging(false);
};

// Hook para agregar y remover los listeners del documento
useEffect(() => {
  if (isDragging) {
    document.addEventListener('mousemove', handleMouseMove);
    document.addEventListener('mouseup', handleMouseUp);
  } else {
    document.removeEventListener('mousemove', handleMouseMove);
    document.removeEventListener('mouseup', handleMouseUp);
  }

  return () => {
    document.removeEventListener('mousemove', handleMouseMove);
    document.removeEventListener('mouseup', handleMouseUp);
  };
}, [isDragging]); // Se ejecuta cada vez que el estado de 'isDragging' cambia
  

 const obtenerFechaActualLocal = () => {
        const ahora = new Date();
        const anio = ahora.getFullYear();
        const mes = String(ahora.getMonth() + 1).padStart(2, '0'); // El mes se cuenta desde 0
        const dia = String(ahora.getDate()).padStart(2, '0');
        const horas = String(ahora.getHours()).padStart(2, '0');
        const minutos = String(ahora.getMinutes()).padStart(2, '0');
      
        return `${anio}-${mes}-${dia}T${horas}:${minutos}`;
      };
      // console.log(groupSelected)
    const [loadingM,setLoadingM]=useState(false);
    const [IpValid,setIpValid]=useState(true)
    const [LatValid,setLatValid]=useState(true)
    const [LonValid,setLonValid]=useState(true)
    const [matchPassword,setMatchPassword]=useState(false)
    const [disabled,setDisabled]=useState(true)
    
   

    // console.log(dataUsers.data)
   
    // console.log(ManttoData)
    
    // const tec_list=useFetch('cassia/ci_elements/technologies','','','GET',server)
    const [msgError,setMsgError]=useState("")
    const [listSearchIP,setListSearchIP]=useState(false)
    // const dataCriticalities=useFetch('cassia/group_types','','','GET',server)
    // console.log(dataCriticalities)
    const dataBrands=useFetch('cassia/brands','','','GET',server)
    const [dataModels,setDataModels]=useState({
      data: [],
      loading: true,
      error: null})
   
        
    

const changeOption=(option,index)=>{
        // console.log(option.filter,option,index)
        let attr=""
      if(option.length!=0){if(option[0].filter=="techDevices"){
        setTechFilter(option)
      }else if(option.filter=="hostModel"){
        attr="model_id"
      }else if(option.filter=="techDevices"){
        attr="device_id"
      }else if(option.filter=="proxy"){
        attr="proxy_id"
      }else if(option.filter=="Grupos"){
        attr="zona_groupid"
      }
}

        
        // setManttoRelation(option.value)
            
    }
    const changeMultiOption=(option,index,titulo)=>{
      let attr=""
      if(titulo=="techDevices"){
        setTechFilter(option)
      }
      if(titulo=="Grupos"){
        setGroupFilter(option)
      }

      if(titulo=="zona"){
        setZoneFilter(option)
      }


        // setManttoData((prevState)=>{
        //     return {
        //         ...prevState,
        //         [attr]:option.map(item => item.value)
        //     }
            
        // })
    }
    // const [severityOptions ,setSeverityOptions] = useState([])
  //  console.log(severityFilter)
    const handleSeverity = (option) => {
    let newSelection;
    if (severityFilter.includes(option)) {
      // Si la opción ya está seleccionada, la removemos del array.
      newSelection = severityFilter.filter((val) => val !== option);
    } else {
      // Si la opción no está seleccionada, la agregamos al array.
      newSelection = [...severityFilter, option];
    }
    // Llama a la función del padre para actualizar el estado.
    setSeverityFilter(newSelection);
  };
  // const [statusOption ,setStatusOption] = useState(['PROBLEM' ,'RESOLVED'])
  //  console.log(statusFilter)
    const handleStatus = (option) => {
     let newSelection;
    if (statusFilter.includes(option)) {
      // Si la opción ya está seleccionada, la removemos del array.
      newSelection = statusFilter.filter((val) => val !== option);
    } else {
      // Si la opción no está seleccionada, la agregamos al array.
      newSelection = [...statusFilter, option];
    }
    // Llama a la función del padre para actualizar el estado.
    setStatusFilter(newSelection);
  };
  const handleAck = (option) => {
     let newSelection;
    if (ackFilter.includes(option)) {
      // Si la opción ya está seleccionada, la removemos del array.
      newSelection = ackFilter.filter((val) => val !== option);
    } else {
      // Si la opción no está seleccionada, la agregamos al array.
      newSelection = [...ackFilter, option];
    }
    // Llama a la función del padre para actualizar el estado.
    setAckFilter(newSelection);
  };
  const handleTicket = (option) => {
     let newSelection;
    if (ticketFilter.includes(option)) {
      // Si la opción ya está seleccionada, la removemos del array.
      newSelection = ticketFilter.filter((val) => val !== option);
    } else {
      // Si la opción no está seleccionada, la agregamos al array.
      newSelection = [...ticketFilter, option];
    }
    // Llama a la función del padre para actualizar el estado.
    setTicketFilter(newSelection);
  };
  const handleTipo = (option) => {
     let newSelection;
    if (tipoFilter.includes(option)) {
      // Si la opción ya está seleccionada, la removemos del array.
      newSelection = tipoFilter.filter((val) => val !== option);
    } else {
      // Si la opción no está seleccionada, la agregamos al array.
      newSelection = [...tipoFilter, option];
    }
    // Llama a la función del padre para actualizar el estado.
    setTipoFilter(newSelection);
  };

return (
    <div>
      {/* <button onClick={togglePanel}>Filtros</button> */}
      {isOpen && (
        <div className="filter-panel "
        style={{ 
            left: `${position.x}px`, 
            top: `${position.y}px`,
            cursor: isDragging ? 'grabbing' : 'grab', // Cambia el cursor
            minHeight:'150px',
            maxWidth:'80px',
            width:'80px',
            height:'150px',
            zIndex:5
          }}
          onMouseDown={handleMouseDown}>
            
          <div className="form-GS-box"> 
                                    
                           
               
                                    
                                    <div className="user-box-GS"  style={{height:'33%'}}>
                                     <Action
                    disabled={false}
                    origen="Azul"
                    titulo={"+ "+capitalizeFirstLetter(lang[languaje]['nuevoRegistro'])}
                    action={crear}
                  />
                                       
                                    </div>
                                   
                                     <div className="user-box-GS"  style={{height:'33%'}}>
                                    <Action
                    disabled={false}
                    origen="Cielo"
                    titulo={" "+capitalizeFirstLetter(lang[languaje]['importar'])}
                    action={import_info}
                  />
                                       
                                    </div>
                                      <div className="user-box-GS"  style={{height:'33%'}}>
                                     <Action
                    disabled={false}
                    origen="Cielo"
                    titulo={" Actualización "+capitalizeFirstLetter(lang[languaje]['masiva'])}
                    action={update_info}
                  />
                 
                                       
                                    </div>
                                    
             
                                   
                                    
                                   
                                   
                                   
                                    
                                    
                                   
                                   
                                   
                                   
                                   
                                    
                                    
                                    
                                </div> 
        </div>
      )}
    </div>
  );
};

export default ActionsPanel;